module.exports = __webpack_public_path__ + "img/p0.6570daba.png";